// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2NKvC","item":"PaymentsMobile_item__3xkht","label":"PaymentsMobile_label__2dWxX","amount":"PaymentsMobile_amount__3qFrx"};